import { createContext } from "react";

export const AppContext = createContext({
  permissions: [],
  hasPermission: () => false,
  userId: null,
});
